<template>
  <div class="showcase-container">
    <a-spin
      :spinning="isLoading"
      class="custom-spinner"
      style="height: 100vh; top: 50%"
    >
      <div ref="scrolledContainer">
        <div class="showcase-title">
          <main-title>Витрина проектов</main-title>
          <a class="showcase-link" href="/showcase" target="_blank">
            Ссылка на витрину
          </a>
        </div>
        <horizontal-filter>
          <template #default>
            <filter-item hash="#new" text="Новые запросы" />
            <filter-item hash="#published" text="Опубликованные" />
            <filter-item hash="#rejected" text="Отклоненные" />
          </template>
          <template #right>
            <label class="panel__total-showcases">
              Всего: {{ totalShowcases }}
            </label>
          </template>
        </horizontal-filter>
        <showcases-table :showcases="showcases" />
      </div>
    </a-spin>
  </div>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import MainTitle from '@/components/titles/MainTitle';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter';
  import FilterItem from '@/components/filter/components/FilterItem';
  import ShowcasesTable from '@/views/administrator/showcases/components/ShowcasesTable.vue';
  const props = defineProps({
    scrollBottom: Number,
  });

  const api = useApi();
  const route = useRoute();
  const totalShowcases = ref(0);
  const showcases = ref([]);
  const isLoading = ref(false);

  const PAGE_SIZE = 20;
  const totalPages = ref(0);
  const lastPage = ref(0);
  const currentPage = ref(1);

  onMounted(async () => {
    await getShowcases();
  });

  watch(
    () => route.hash,
    async () => {
      showcases.value = [];
      totalPages.value = 0;
      currentPage.value = 1;
      lastPage.value = 0;
      await getShowcases();
    }
  );

  watch(
    () => props.scrollBottom,
    async () => {
      if (totalPages.value === 0 || currentPage.value < totalPages.value) {
        currentPage.value++;
        await getShowcases();
      }
    }
  );

  const getShowcases = async () => {
    try {
      const tab = route.hash ? route.hash.replace('#', '') : 'new';
      const response = await api.showcase.search(
        new URLSearchParams({
          role: route.meta.role,
          isPublic: tab === 'published' ? 1 : 0,
          filter: tab,
          'per-page': PAGE_SIZE,
          page: currentPage.value,
        })
      );
      totalShowcases.value = response.showcases.total;
      totalPages.value = response.showcases.pages.total;
      if (lastPage.value !== currentPage.value) {
        showcases.value = showcases.value.concat(response.showcases.items);
        lastPage.value = currentPage.value;
      }
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .showcase-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .showcase-link {
      color: $color-link-primary;
      text-decoration: underline;
    }
  }

  .showcase-container {
    margin-bottom: 100px;
  }
</style>
